import { Plus } from "lucide-react";
import { useTranslation } from "react-i18next";
import { OutlinedTextBlueButton } from "src/components/Default/LekUI/Button";
import { ConversationList } from "src/components/GlobalChatbot/ConversationList";

interface ChatbotHistorySidebarProps {
	activeConversationId: string | null;
	onSelect: (conversationId: string) => void;
	onDeleted: (conversationId: string) => void;
	onNewConversation: () => void;
}

export const ChatbotHistorySidebar = ({
	activeConversationId,
	onSelect,
	onDeleted,
	onNewConversation,
}: ChatbotHistorySidebarProps) => {
	const { t } = useTranslation();

	return (
		<div className="chatbot-history-sidebar">
			<div className="chatbot-header">
				<span className="size-16 flex-1 m-0">
					{t("globalChatbot.history.title", "Historia pytań")}
				</span>
				<OutlinedTextBlueButton
					data-test-id="global-chatbot-sidebar-new-button"
					startIcon={<Plus className="icon-small" />}
					onClick={onNewConversation}
				>
					{t("globalChatbot.new", "Nowa")}
				</OutlinedTextBlueButton>
			</div>
			<ConversationList
				activeConversationId={activeConversationId}
				onSelect={onSelect}
				onDeleted={onDeleted}
			/>
		</div>
	);
};
